
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "ci-rating-icons",
})
export default class extends Vue {
  @Prop({ default: () => 0 }) public value!: number;
  @Prop({ default: () => false }) public short!: boolean;
  @Prop({ default: () => "text-lg" }) public sizeClass!: string;
  @Prop({ default: () => "primary" }) public activeColor!: string;
  @Prop({ default: () => "medium" }) public inactiveColor!: string;
  @Prop({ default: () => "mdi-star" }) public activeIcon!: string;
  @Prop({ default: () => "mdi-star-outline" }) public inactiveIcon!: string;

  public limit: number = 5;

  public get activeStars(): number[] {
    return new Array(this.value);
  }

  public get inactiveStars(): number[] {
    return new Array(this.limit - this.value);
  }

  public get activeClasses(): string {
    return `${this.sizeClass} text-${this.activeColor} mdi ${this.activeIcon}`;
  }

  public get inactiveClasses(): string {
    return `${this.sizeClass} text-${this.inactiveColor} mdi ${this.inactiveIcon}`;
  }
}
